<script setup lang="ts">

import Fuse from 'fuse.js'

const query = ref('')
const { data: articles } = await useAsyncData('search-data', () => queryCollectionSearchSections('articles'))

const fuse = new Fuse(articles.value!, {
  keys: ['title', 'description', 'content']
})

type ItemType<T> = T extends Ref<infer R>? R extends (infer W)[]? W : undefined: T extends (infer X)[]? X: undefined;

const result = computed(() => {
  return fuse.search<ItemType<typeof articles>>(toValue(query) || '脚手架').slice(0, 10)
})

const emits = defineEmits(['close'])
async function openPage(page: ItemType<typeof articles>) {
  await navigateTo(page?.id, {
    open: {
      target: '_blank'
    }
  })
  emits('close')
}

</script>

<template>
  <div class="full-search">
    <a-input v-model:value="query" allowClear placeholder="搜索全文..." class="w-full" />
    <ul class="pt-[10px] h-vh-400px overflow-hidden">
      <li v-for="link of result" :key="link.item?.id" class="mt-2" @click="openPage(link.item)" >
        <div class="w-full flex gap-col-2 flex-col justify-between items-start cursor-pointer hover:bg-[var(--btn-bg)] pl-[10px] pr-[10px] pt-[4px] pb-[4px]">
          <span class="color-[var(--bold-color)]">{{ link.item?.title }}</span>
          <span class="color-[var(--text-color)] text-[12px] truncate-2">
              {{ link.item?.content }}
            </span>
        </div>
      </li>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
  .full-search {
    .ant-input-affix-wrapper,
    :deep(.ant-input) {
      background: var(--code-bg);
      color: var(--text-color);
      border-color: var(--border-color);
    }

    :deep(span:has(.ant-input:focus)) {
      box-shadow: none !important;
      border-color: var(--bold-color);
    }
  }

</style>